import { GET_SOCIETY_DASHBOARD, GET_OPERATIONS_DASHBOARD } from '../../index.types';

export function getSocietyDashboard(data) {
    return {
        type: GET_SOCIETY_DASHBOARD,
        data
    };
}

// Consolidated complaints + tasks dashboard. Shared by SocietyPortal
// (no data — auto-scoped from the session) and SocietyController
// (society_id optional — omit for cross-society aggregate).
export function getOperationsDashboard(data) {
    return {
        type: GET_OPERATIONS_DASHBOARD,
        data
    };
}
